import { createSlice } from '@reduxjs/toolkit';

type State = { buildings: Record<string, unknown> | undefined };

const initialState: State = { buildings: undefined };

const locationStructureSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    updateLocations(state: State, action) {
      state.buildings = action.payload;
    },
  },
});

export const { updateLocations } = locationStructureSlice.actions;

export default locationStructureSlice.reducer;
